import React from 'react';
import styled from 'styled-components';

interface TelegramIconProps {
  className?: string;
  style?: React.CSSProperties;
}

const StyledIcon = styled.div`
  width: 100%;
  height: 100%;
  background-color: currentColor;
  mask: url('/images/fredcon26/telegram-icon.svg') no-repeat center;
  mask-size: contain;
  display: inline-block;
`;

export const TelegramIcon: React.FC<TelegramIconProps> = ({
  className,
  style
}) => {
  return <StyledIcon className={className} style={style} />;
};
